import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SneakPeekProduct } from '@app/scoop/models/sneak-peek-product-view.model';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { ProductAnalyticsService } from '@usf/ngrx-product';
@Component({
  selector: 'app-scoop-product-preview',
  templateUrl: './scoop-product-preview.component.html',
  styleUrls: ['./scoop-product-preview.component.scss'],
})
export class ScoopProductPreviewComponent {
  @Input() sneakPeekProducts: SneakPeekProduct[];

  @Output() productClick: EventEmitter<any> = new EventEmitter();

  constructor(
    readonly panAppState: PanAppState,
    readonly platformService: PlatformService,
    readonly productAnalyticsService: ProductAnalyticsService,
  ) {}

  trackByIndex = (index: number, id: any) => index;

  onProductClick(productNumber: number, merchRank: number) {
    this.productClick.emit({
      productNumber,
      lnksrc: 'scoopPreview',
      merchRank,
    });
  }

  trackProductImageClick(
    sneakPeekProduct: SneakPeekProduct,
    merchRank: number,
  ) {
    this.productAnalyticsService.trackProductImageClick(
      sneakPeekProduct?.summary?.divisionNumber,
      sneakPeekProduct?.productNumber,
      sneakPeekProduct?.trackingAttributes,
      merchRank,
    );
  }

  onProductImageClick(sneakPeekProduct: SneakPeekProduct, merchRank: number) {
    this.trackProductImageClick(sneakPeekProduct, merchRank);
    this.onProductClick(sneakPeekProduct?.productNumber, merchRank);
  }
}
